import Nav from "../../components/Nav"
import Banner from "../../components/Banner"
import Footer from "../../components/Footer"
import Content from "../../components/Content"

const Home = () => {
  return(
    <>
      <Nav />
      <Banner />
      <Content />
      <Footer />
    </>
  )
}

export default Home